module.exports = __webpack_public_path__ + "media/images/icon-svg/shopping-bag-069ad7d11303a0368394e61c81d82f46.svg";